
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 62 56","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M60.465 48.468L34.454 3.537a3.992 3.992 0 00-6.91 0l-26.01 44.93a3.992 3.992 0 003.456 5.989h52.02a3.992 3.992 0 003.454-5.988zm-27.846-2.994h-3.071c-.682 0-1.744 0-1.744-1.516v-3.793c0-1.478 1.062-1.516 1.744-1.516h1.934c2.578 0 2.767.303 2.767 3.792 0 2.995-.265 3.033-1.63 3.033zm.91-12.551a7.915 7.915 0 00-.038.91c-.15 2.806-.189 3.071-1.781 3.071h-1.328c-1.63 0-1.63-.265-1.82-2.958 0-.492-.038-.758-.038-1.023-.265-4.816-.91-8.077-.91-12.096 0-1.138 0-2.275 1.517-2.275h3.792c1.517 0 1.517 1.137 1.517 2.275 0 4.019-.646 7.318-.91 12.096z","fill":"currentColor"}})])
          )
        }
      }
    